import { useState, type FormEvent } from 'react';
import type { UsuarioDTO } from '@medicov1/shared';
import { chamar } from '../api';

export function Entrar({ aoEntrar }: { aoEntrar: (u: UsuarioDTO) => void }) {
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);

  async function enviar(evento: FormEvent) {
    evento.preventDefault();
    setErro('');
    setEnviando(true);
    try {
      aoEntrar(await chamar<UsuarioDTO>('/sessao', { metodo: 'POST', corpo: { usuario, senha } }));
    } catch (e) {
      setErro(e instanceof Error ? e.message : 'Nao consegui entrar.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <main style={{ display: 'grid', placeItems: 'center', minHeight: '100%', padding: 'var(--gap-4)' }}>
      <form onSubmit={enviar} className="cartao" style={{ width: 'min(100%, 360px)', display: 'grid', gap: 'var(--gap-4)' }}>
        <div>
          <h1 style={{ fontFamily: 'var(--serif)', fontSize: 27, fontWeight: 400 }}>saudev1</h1>
          <p style={{ color: 'var(--texto-3)', fontSize: 13, fontFamily: 'var(--mono)' }}>
            monitor de apoio — não é dispositivo médico
          </p>
        </div>

        <div className="campo">
          <label htmlFor="usuario">Seu nome</label>
          {/* `autoCapitalize` desligado: o teclado do Android capitaliza a
              primeira letra sozinho, e "Ildete" não é o que está no banco.
              O servidor também aceita maiúscula, mas evitar já é melhor. */}
          <input id="usuario" type="text" autoComplete="username" required
            autoCapitalize="none" autoCorrect="off" spellCheck={false}
            placeholder="ilton" value={usuario}
            onChange={(e) => setUsuario(e.target.value)} />
        </div>

        <div className="campo">
          <label htmlFor="senha">Senha</label>
          <input id="senha" type="password" autoComplete="current-password" required
            value={senha} onChange={(e) => setSenha(e.target.value)} />
        </div>

        {erro && <p className="aviso-erro">{erro}</p>}

        <button className="botao" type="submit" disabled={enviando}>
          {enviando ? 'Entrando…' : 'Entrar'}
        </button>
      </form>
    </main>
  );
}
